/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { TenantTypesEnum } from "Constants/TenantTypes";
import { IM365CopilotBenefit } from "Interfaces/Benefits/IM365CopilotBenefit";
import { IFilterValue } from "Interfaces/IFilterValue";

import { IM365CopilotBenefitState } from "./IM365CopilotBenefitState";

export const getM365CopilotBenefits = (state: IM365CopilotBenefitState): IM365CopilotBenefit[] =>
  state.benefits;

export const getM365CopilotBenefitsIsLoading = (state: IM365CopilotBenefitState): boolean =>
  state.isLoading;

export const getM365CopilotBenefitsLoadError = (state: IM365CopilotBenefitState): string =>
  state.loadBenefitsError;

export const getM365CopilotBenefitsSearchKey = (state: IM365CopilotBenefitState): string =>
  state.searchText;

export const getM365CopilotBenefitsFilteredCount = (state: IM365CopilotBenefitState): number =>
  state.filteredCount;

export const getM365CopilotBenefitsCurrentPage = (state: IM365CopilotBenefitState): number =>
  state.currentPage;

export const getM365CopilotBenefitsPageSize = (state: IM365CopilotBenefitState): number =>
  state.pageSize;

export const getM365CopilotBenefitsFilterValues = (
  state: IM365CopilotBenefitState
): IFilterValue[] => state.m365CopilotFilterValues;

export const getM365CopilotBenefitsCurrentTenant = (
  state: IM365CopilotBenefitState
): TenantTypesEnum | undefined => state.currentTenant;
